import * as React from 'react';
import PageSwitch, { SwitchValue } from '../containers_v2/map/PageSwitch';
import { Calendar, Menu } from 'lucide-react';

export type viewType = 'list' | 'calendar' | 'list_beta'

export function ViewSwitch(props: { dispatch: ({ type, data }) => void, value?: viewType }) {
	const [view, setView] = React.useState<viewType>(props.value ?? 'calendar');

	function setViewAndDispatch(e: viewType) {
		setView(e);
		props.dispatch({ type: 'view', data: e });
		localStorage.setItem('calendarView', e);
	}

	const viewList: SwitchValue<viewType>[] = [
		{ value: 'calendar', img: <Calendar/>, onClick: setViewAndDispatch },
		{ value: 'list', img: <Menu/>, onClick: setViewAndDispatch }
	];

	return (
		<PageSwitch<viewType> selectedValue={view} background={true} list={viewList}/>
	);
}